import { MerchantLogo } from 'src/components/Logo/MerchantLogo';

export const Logo = () => {
    return <MerchantLogo />;
};
